import React from "react";

const uiUtils = {
    scrollToBottom() {
        return window.scrollTo({
                top: document.body.scrollHeight,
                left: 0,
                behavior: "smooth",
            })
    },

    parseText (text) {
        return text?.split('\n').map((line, index) => {
            const hasTab = line.startsWith('\t');
            const cleanLine = line.replace(/^\t+/, '');

            return (
                <React.Fragment key={index}>
                    <span className={hasTab ? 'tabbed-line' : ''}> {cleanLine} </span> {!hasTab && <br />}
                </React.Fragment>
            );
        });
    },

    isInsideDialog(element) {
        if (!element) return false;
        let current = element;
        while (current && current !== document.body) {
            // a div-based modal (Fundamentals/Drawer) needs its popups in the top layer too, not portaled behind it
            if (current.tagName === 'DIALOG' || (current.getAttribute('role') === 'dialog' && current.getAttribute('aria-modal') === 'true')) return true;
            current = current.parentElement;
        }
        return false;
    },

    isInsideReactModal(element) {
        if (!element) return false;
        let current = element;
        while (current && current !== document.body) {
            const className = current.className || '';
            const isModal = 
                // Bootstrap/common modal classes
                className.includes('modal') ||
                className.includes('Modal') ||
                // React Modal library
                className.includes('ReactModal') ||
                // MUI/Material-UI
                className.includes('MuiModal') ||
                className.includes('MuiDialog') ||
                // Custom modal indicators
                current.getAttribute('role') === 'dialog' ||
                current.getAttribute('aria-modal') === 'true';
                
            if (isModal) return true;
            current = current.parentElement;
        }
        return false;
    },

    supportsPopover() {
        return typeof HTMLElement !== 'undefined' && 'popover' in HTMLElement.prototype;
    }
};

export default uiUtils;
